import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;

  .group-value {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 8px;

    @media ${({ theme }) => theme.devices.mobile} {
      gap: 8px;
      margin-top: 12px;
    }

    input {
      width: 50%;
      max-width: 220px;
      padding: 12px 8px;
      font-weight: 300;

      @media ${({ theme }) => theme.devices.mobile} {
        max-width: 100px;
        font-size: 16px;
        padding: 8px;
      }
    }

    span {
      width: 116px;

      @media ${({ theme }) => theme.devices.mobile} {
        width: 80px;
      }
    }
  }

  .lang {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 8px;
    background-color: rgba(237, 97, 95, 0.7);
    border: 1px solid ${({ theme }) => theme.colors.primary.light};

    button {
      display: flex;
      align-items: center;
      background-color: transparent;
      border: 0;
      color: ${({ theme }) => theme.colors.grey.white};
    }
  }

  label {
    font-size: 20px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 18px;
    }

    span {
      text-transform: none;
      font-size: 16px;

      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 12px;
      }
    }
  }

  input,
  select,
  textarea {
    border: 1px solid ${({ theme }) => theme.colors.grey.white};
    background-color: ${({ theme }) => theme.colors.grey[100]};
    margin-top: 2px;
    padding: 12px 24px;
    border-radius: 32px;
    font-size: 20px;
    appearance: none;

    @media ${({ theme }) => theme.devices.mobile} {
      padding: 12px 8px;
      font-size: 16px;
    }

    &:disabled {
      background-color: rgba(256, 256, 256, 0.9);
      color: ${({ theme }) => theme.colors.grey[200]};
    }

    ${({ $passwordView }) =>
      $passwordView &&
      css`
        text-security: disc;
        -webkit-text-security: disc;
      `}

    ${({ $error }) =>
      $error &&
      css`
        border: 1px solid ${({ theme }) => theme.colors.outher.danger};
        color: ${({ theme }) => theme.colors.outher.danger};

        &::placeholder {
          color: ${({ theme }) => theme.colors.outher.danger};
        }
      `}
  }

  select {
    color: ${({ theme, $select }) =>
      !$select ? theme.colors.grey[500] : theme.colors.grey.black};

    option {
      color: ${({ theme }) => theme.colors.grey.black};

      &:disabled {
        color: ${({ theme }) => theme.colors.grey[200]} !important;
      }
    }
  }

  textarea {
    resize: none;
    height: 200px;
  }

  > div {
    display: flex;
    align-items: center;
    margin-top: 8px;
    gap: 4px;

    input[type='radio'] {
      padding: 8px;

      &:checked {
        border-color: #007bff;
        background-color: #007bff;
      }
    }
  }
`;

export const WrapChangePassword = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    background-color: transparent;
    border: 0;
    margin-top: 8px;
    color: ${({ theme }) => theme.colors.grey.white};
    text-decoration: underline;

    &:hover {
      transition: 0.7s;
      color: ${({ theme }) => theme.colors.grey[200]};
    }
  }
`;

export const ViewButton = styled.button`
  position: absolute;
  top: 28px;
  right: 12px;
  transform: translateY(40%);
  /* transform: translateY(150%); */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 0;
  background-color: transparent;

  @media ${({ theme }) => theme.devices.mobile} {
    top: 32px;
  }

  svg {
    width: 28px;
    height: 28px;
    color: ${({ theme }) => theme.colors.grey.black};

    @media ${({ theme }) => theme.devices.mobile} {
      width: 24px;
      height: 24px;
    }
  }

  img {
    width: 28px;
  }
`;

export const Error = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;

  svg {
    width: 20px;
    color: ${({ theme }) => theme.colors.outher.danger};
  }

  span {
    color: ${({ theme }) => theme.colors.outher.danger};
    margin-bottom: -2px;
  }
`;
